import createClient from 'openapi-fetch';
import { environment } from '@/env/environment';
import { authFetch } from '@/lib/auth/auth-fetch';
import { ApiError } from './errors';
import type { components, paths } from './schema';

export type Schemas = components['schemas'];

/** The typed API. Every call goes through authFetch (bearer token, refresh, one 403 retry). */
export const api = createClient<paths>({ baseUrl: environment.apiBaseUrl, fetch: authFetch });

interface Result {
  data?: unknown;
  error?: unknown;
  response: Response;
}

/** Resolves to the response data, or throws an ApiError so queries and mutations see a failure. */
export async function unwrap<R extends Result>(call: Promise<R>): Promise<NonNullable<R['data']>> {
  let result: R;
  try {
    result = await call;
  } catch (cause) {
    throw ApiError.network(cause);
  }
  if (!result.response.ok) {
    throw new ApiError(result.response.status, result.error as never);
  }
  return result.data as NonNullable<R['data']>;
}
